import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { NavLink, useHistory } from 'react-router-dom'
import Logo from '../../Images/Logo.webp'
import classNames from 'classnames'
import { Button, CircularProgress, Typography, Link } from '@material-ui/core'
import './../../Account/Login.css'
import './LoginRetailer.css';
import Popup from '../Popup'
import { login, signupWithGoogle } from '../../Backend/firebase/auth'
import { useDispatch } from 'react-redux'
import { loginSave, logoutSave } from '../../DataStore/Slices/userSlice'
import db, { auth, googleProvider } from '../../Backend/firebase/firebase'
import CustomAlert from '../CustomAlert'
import { sleep } from '../Models/CommonFunc'
import ForgotPassword from '../ForgotPassword'
import { Helmet } from 'react-helmet'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://kaipsoolretail.web.app/" target="_blank">
        Kaipsool Pharmatech
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export { Copyright }

function LoginRetailer({ isCaptchaVisible }) {
  const { register, handleSubmit, reset, errors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [openPopup, setOpenPopup] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [verifyCaptcha, setVerifyCaptcha] = useState(false)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')

  const handleCaptchaVerification = (response) => {
    if (response) {
      setVerifyCaptcha(true)
    } else {
      setVerifyCaptcha(false)
    }
  }

  const routeOnLogin = async (user) => {
    const rolessRef = db.collection('Users').doc(user.uid)
    const doc = await rolessRef.get()
    if (!doc.exists) {
      console.log('No such document!')
      var userData = {
        name: '',
        email: '',
        uid: '',
        userRole: '',
        provider: user.providerData[0].providerId,
      }
      dispatch(
        loginSave({
          user: userData,
        }),
      )
    } else {
      var roleData = doc.data()
      var userData = {
        name: roleData.name,
        email: roleData.email,
        uid: roleData.uid,
        userRole: roleData.userRole,
        provider: user.providerData[0].providerId,
        storeName: roleData?.storeName,
        storeAddress: roleData?.storeAddress,
        storeCity: roleData?.storeCity,
        zipcode: roleData?.zipcode,
        city: roleData?.city,
        nameTitle: roleData?.nameTitle ? roleData?.nameTitle : '',
        function: roleData?.function,
        remarks: roleData?.remarks,
        phoneNumber: roleData?.phoneNumber,
        storeWebsite: roleData?.storeWebsite,
        country: roleData?.country,
        isPlanActivated: true,
      }
      dispatch(
        loginSave({
          user: userData,
        }),
      )

      localStorage.setItem(process.env.REACT_APP_EMPLOYER_ISLOGIN, true);
      if(roleData.userRole == "Chemist" || roleData.userRole == "Wholesaler") {
        history.push('/supply/dashboard')
      } else {
        history.push('/activity/dashboard')
      }
    }
  }

  const onSubmit = async (data) => {
    // if (verifyCaptcha || !isCaptchaVisible) {
    let user
    setIsLoading(true)
    try {
      user = await login(data)
      const rolessRef = db.collection('Users').doc(user.uid)
      const doc = await rolessRef.get()
      var roleData = doc.data()
      if (roleData.userRole === 'User') {
        setNotificationMessage(
          'You are using retailer login, please go to candidate login and try again',
        )
        setOpenNotify(true)
        setAlertType('error')
        await sleep(2000)
        logoutUser()
      } else {
        // if (user && user.emailVerified) {
        if (user) {
          await routeOnLogin(user)
          reset()
        } else {
          await user.sendEmailVerification()
          setIsLoading(false)
          history.push('/emailalert')
        }
      }
    } catch (error) {
      console.log('ERROR ==> ', error)
      if (error.code === 'auth/wrong-password') {
        setNotificationMessage(
          'Username or password is incorrect, Please try again!',
        )
        setOpenNotify(true)
        setAlertType('error')
        setIsLoading(false)
      } else if (error.code === 'auth/too-many-requests') {
        setNotificationMessage(
          'Your account has been temporarily disabled due to many failed login attempts. Please try again later or reset your password!',
        )
        setOpenNotify(true)
        setAlertType('error')
        setIsLoading(false)
      } else {
        setNotificationMessage(
          'Username or password is incorrect, Please try again!',
        )
        setOpenNotify(true)
        setAlertType('error')
        setIsLoading(false)
      }
    }
    // } else {
    //     setNotificationMessage('Please verify the captcha first!');
    //     setOpenNotify(true);
    //     setAlertType('error');
    // }
  }

  const logoutUser = async () => {
    var access_token = sessionStorage.getItem('access_token')
    if (access_token) {
      sessionStorage.removeItem('access_token')
    } else {
      auth.signOut()
    }
    dispatch(logoutSave())
    window.location.href = '/'
  }

  const handleOnTapGoogle = async () => {
    var message = '';
    let firebaseUser = null;
    await auth.signInWithPopup(googleProvider)
      .then(async ({ user }) => {
        firebaseUser = user;
      })
      .catch(error => message = error.message);

    const rolessRef = db.collection("Users").doc(firebaseUser.uid);
    const doc = await rolessRef.get();
    if (!doc.exists) {
      let user;
      let createDataForFirebase = {
        uid: firebaseUser.uid,
        storeName: firebaseUser?.displayName,
        fullName: firebaseUser?.displayName,
        email: firebaseUser?.email,
        provider: firebaseUser?.providerData[0]?.providerId,
        password: '',
        roleName: 'Retailer',
        storeWebsite: '',
        storeAddress: '',
        storeCity: '',
        zipcode: '',
        gstNo: '',
        drugLicense: '',
        nameTitle: '',
        name: '',
        homeDelivery: 'Select Option',
        areaCovers: 'Select Option',
        remarks: '',
        phoneNumber: '',
        retailerImage: null,
        country: 'India',
        isPlanActivated: true,
      }
      user = await signupWithGoogle(createDataForFirebase)
      if (user != null) {
        setIsLoading(false)
        var userData = {
          name: firebaseUser.displayName,
          email: firebaseUser.email,
          uid: firebaseUser.uid,
          userRole: 'Retailer',
          provider: firebaseUser?.providerData[0]?.providerId,
          storeName: '',
          storeAddress: '',
          storeCity: '',
          zipcode: '',
          city: '',
          nameTitle: '',
          function: '',
          remarks: '',
          phoneNumber: '',
          storeWebsite: '',
          country: '',
          isPlanActivated: true,
        }
        dispatch(
          loginSave({
            user: userData,
          }),
        )
        history.push('/activity/dashboard')
      } else {
        setNotificationMessage(
          'Something went wrong, Please try again later!!',
        )
        setOpenNotify(true)
        setAlertType('error')
      }
    } else {
      setIsLoading(false)
      console.log('document!', doc.data());
      var roleData = doc.data();
      var userData = {
        name: roleData?.name,
        email: roleData?.email,
        uid: roleData?.uid,
        userRole: roleData?.userRole,
        provider: roleData?.provider,
        storeName: roleData?.name,
        storeAddress: roleData?.storeAddress,
        storeCity: roleData?.storeCity,
        zipcode: roleData?.zipcode,
        city: roleData?.city,
        nameTitle: roleData?.nameTitle ? roleData?.nameTitle : '',
        function: roleData?.function,
        remarks: roleData?.remarks,
        phoneNumber: roleData?.phoneNumber,
        storeWebsite: roleData?.storeWebsite,
        country: roleData?.country,
        isPlanActivated: true,
      }
      dispatch(
        loginSave({
          user: userData,
        }),
      )
      setIsLoading(false)
      history.push('/activity/dashboard')
    }
  };

  return (
    <>
      <div className="container-fluid registerRetailer">
        <Helmet>
          <meta
            name="description"
            content="Please register as retailer to post products who will help you to get best talent..."
          />
          <title>Retailer Login | Kaipsool Pharmatech</title>
        </Helmet>
        <div className="row">
          <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
            <div className="row">
              <div className="col-md-12 text-center">
                <NavLink className="" to="/">
                  <img
                    className="img-fluid"
                    src={Logo}
                    alt="Website Logo"
                    width="200px"
                  />
                </NavLink>
              </div>
              <div className="col-md-12 mt-4">
                <div className="form-block">
                  <header className="login__header">
                    <div className="header__block header__block_signup">
                      <h4 className="header__block_title">Login To Your Account</h4>
                    </div>
                    <hr className="header__block_sep" />
                  </header>
                  <main className="main">
                    <div className="main__block main__block_signup">
                      <div className="main__block_left">
                        <div className="sign-up">
                          <form className="sign-up__form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="sign-up__block">
                              <label className="sign-up__label" for="email">
                                Enter your email <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >*</span>
                              </label>
                              <input
                                placeholder="e.g maister909@gmail.com"
                                type="email"
                                className={classNames(
                                  'sign-up__field sign-up__field_email',
                                  { 'is-invalid': errors.email },
                                )}
                                name="email"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your email address!',
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.email && errors.email.message}
                              </small>
                            </div>
                            <div className="sign-up__block mt-3">
                              <label className="sign-up__label" for="password">
                                Enter your password <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >*</span>
                              </label>
                              <input
                                placeholder="e.g qwerty!123"
                                type="password"
                                className={classNames(
                                  'sign-up__field sign-up__field_username',
                                  { 'is-invalid': errors.password },
                                )}
                                name="password"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your password!',
                                  minLength: {
                                    value: 6,
                                    message:
                                      'Password should be at least 6 characters!',
                                  },
                                  maxLength: {
                                    value: 100,
                                    message:
                                      'Password should be 15 length maximum!',
                                  },
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.password && errors.password.message}
                              </small>
                            </div>
                            <div className="sign-up__block mt-4">
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="small"
                                className="login__btn sign-up__submit"
                              >
                                {isLoading ? (
                                  <CircularProgress size={18} />
                                ) : (
                                  'Log In'
                                )}
                              </Button>
                            </div>
                          </form>
                        </div>
                        <hr />
                        <p className="content__footer-text">
                          Don’t have an account? <a
                            className="content__footer__link"
                            href="/activity/Register"
                            title="Sign up via form"
                            onclick={() => history.push('/activity/Register')}
                          >
                            Register here
                          </a>
                        </p>
                      </div>
                      {/* <span className="main__block_sep"></span>
                      <div className="main__block_right social">
                        <div className="social__btns btns">
                          <button
                            className="btns__signup social__btns_gl"
                            title="Sign Up with Google +"
                            onClick={handleOnTapGoogle}
                          >
                            <span>Login With Google</span>
                          </button><br />
                          <p className="content__footer-text">
                            Don’t have an account? <a
                                className="content__footer__link"
                                href="/activity/Register"
                                title="Sign up via form"
                                onclick={()=> history.push('/activity/Register')}
                            >
                                Register here
                            </a>
                          </p>
                          
                        </div>
                      </div> */}
                    </div>
                  </main>
                </div>



              </div>
              <div className="col-md-12 p-5">
                <Copyright />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title="Forgot Password"
      >
        <ForgotPassword />
      </Popup>

      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType || 'error'}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default LoginRetailer
